import { LOCKUP_ADDRESSES } from '@features/lockup/constants';
import { NetworkName } from '@features/lockup/types';
import SmartItem from '@features/lockup/ui/smart-contracts-modal/item';
import SmartItemMobile from '@features/lockup/ui/smart-contracts-modal/item-mobile';
import { ModalPortal } from '@features/modal/ui/modal';
import { AppState } from '@state';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';
import styles from './styles.module.scss';

const SmartContractModal = (props: any) => {
  const networkName = useSelector<AppState, NetworkName>(state => state.lockup.networkName);
  const [openContract, setOpenContract] = useState<any[]>([
    {
      name: 'lockup',
      isOpen: false
    },
    {
      name: '1 day',
      isOpen: false
    },
    {
      name: '3 days',
      isOpen: false
    },
    {
      name: '7 days',
      isOpen: false
    },
    {
      name: '14 days',
      isOpen: false
    },
    {
      name: '21 days',
      isOpen: false
    },
    {
      name: '28 days',
      isOpen: false
    },
    {
      name: '90 days',
      isOpen: false
    },
    {
      name: '180 days',
      isOpen: false
    },
    {
      name: '365 days',
      isOpen: false
    }
  ]);

  function onOpenContract(name: string) {
    const newState = openContract.map(c => {
      if (c.name === name) {
        return {
          name: c.name,
          isOpen: !c.isOpen
        };
      }

      return {
        ...c,
        isOpen: false
      };
    });

    setOpenContract(newState);
  }

  return (
    <ModalPortal title={'Abyss Lockup Smart Contracts'} dialogClass={styles.modalMobile} onClose={props.onClose}>
      <Scrollbar
        noScrollX
        style={{ width: 980, height: 490, maxHeight: 'calc(100vh - 240px)', minHeight: 250 }}
        className={styles.hiddenMobile}>
        <div className={styles.smartItems}>
          <SmartItem
            nameContract="Lockup"
            address={LOCKUP_ADDRESSES[networkName].lockup}
            description={'A smart contract that stores tokens requested for withdrawal.'}
          />

          <SmartItem
            nameContract="Safe1"
            address={LOCKUP_ADDRESSES[networkName].safe1}
            description={`Deposits and withdrawals. 1 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minute' : 'day'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe3"
            address={LOCKUP_ADDRESSES[networkName].safe3}
            description={`Deposits and withdrawals. 3 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe7"
            address={LOCKUP_ADDRESSES[networkName].safe7}
            description={`Deposits and withdrawals. 7 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe14"
            address={LOCKUP_ADDRESSES[networkName].safe14}
            description={`Deposits and withdrawals. 14 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe21"
            address={LOCKUP_ADDRESSES[networkName].safe21}
            description={`Deposits and withdrawals. 21 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe28"
            address={LOCKUP_ADDRESSES[networkName].safe28}
            description={`Deposits and withdrawals. 28 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe90"
            address={LOCKUP_ADDRESSES[networkName].safe90}
            description={`Deposits and withdrawals. 90 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe180"
            address={LOCKUP_ADDRESSES[networkName].safe180}
            description={`Deposits and withdrawals. 180 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />

          <SmartItem
            nameContract="Safe365"
            address={LOCKUP_ADDRESSES[networkName].safe365}
            description={`Deposits and withdrawals. 365 ${
              networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
            } unlock waiting period.`}
          />
        </div>
      </Scrollbar>

      <SmartItemMobile
        nameContract="Lockup"
        address={LOCKUP_ADDRESSES[networkName].lockup}
        description={'A smart contract that stores tokens requested for withdrawal.'}
        onClick={() => onOpenContract('lockup')}
        isOpen={openContract[0].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe1"
        address={LOCKUP_ADDRESSES[networkName].safe1}
        description={`Deposits and withdrawals. 1 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minute' : 'day'
        } unlock waiting period.`}
        onClick={() => onOpenContract('1 day')}
        isOpen={openContract[1].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe3"
        address={LOCKUP_ADDRESSES[networkName].safe3}
        description={`Deposits and withdrawals. 3 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('3 days')}
        isOpen={openContract[2].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe7"
        address={LOCKUP_ADDRESSES[networkName].safe7}
        description={`Deposits and withdrawals. 7 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('7 days')}
        isOpen={openContract[3].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe14"
        address={LOCKUP_ADDRESSES[networkName].safe14}
        description={`Deposits and withdrawals. 14 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('14 days')}
        isOpen={openContract[4].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe21"
        address={LOCKUP_ADDRESSES[networkName].safe21}
        description={`Deposits and withdrawals. 21 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('21 days')}
        isOpen={openContract[5].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe28"
        address={LOCKUP_ADDRESSES[networkName].safe28}
        description={`Deposits and withdrawals. 28 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('28 days')}
        isOpen={openContract[6].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe90"
        address={LOCKUP_ADDRESSES[networkName].safe90}
        description={`Deposits and withdrawals. 90 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('90 days')}
        isOpen={openContract[7].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe180"
        address={LOCKUP_ADDRESSES[networkName].safe180}
        description={`Deposits and withdrawals. 180 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('180 days')}
        isOpen={openContract[8].isOpen}
      />

      <SmartItemMobile
        nameContract="Safe365"
        address={LOCKUP_ADDRESSES[networkName].safe365}
        description={`Deposits and withdrawals. 365 ${
          networkName !== 'mainnet' && networkName !== 'bscMainnet' ? 'minutes' : 'days'
        } unlock waiting period.`}
        onClick={() => onOpenContract('365 days')}
        isOpen={openContract[9].isOpen}
      />
    </ModalPortal>
  );
};

export default SmartContractModal;
